<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Libreta de contactos</ion-title>
  </ion-toolbar>

  <ion-toolbar>
    <form [formGroup]="formSearchContactEdit">
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ion-input
              #searchInput
              type="text"
              label="Empresa, NIF, nombre, apellidos o email"
              formControlName="searchTerm"
              (ionInput)="handleChangeTerm($event)"
              debounce="300"
              placeholder="Ejemplo: Transportes A..."
              labelPlacement="floating"
              fill="outline"
              mode="md"
              clearInput
            ></ion-input>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (decaCompanyStoreService.companiesLoading()) {
    <lib-spinner-loading></lib-spinner-loading>
  } @else {
    @for (company of filteredCompanies(); track company.id) {
      <ion-item
        button="true"
        (click)="handleSelectCompany(company)"
      >
        <ion-label>
          <p>
            <strong>{{ company.companyName }}</strong>
            ({{ company.taxId }})
            @if (company.isCarrier) {
              <span class="tag"> Transportista</span>
            }
            @if (company.isShipper) {
              <span class="tag"> Cargador</span>
            }
          </p>

          <p>
            <span> {{ company.contactFirstName }}</span>
            <span> {{ company.contactLastName }}</span>
            <span> ({{ company.contactEmail }})</span>
          </p>
        </ion-label>
      </ion-item>
    } @empty {
      <ion-item>
        <ion-label>
          <p class="ion-text-center">
            @if ((searchTerm()?.length ?? 0) === 0) {
              No hay contactos guardados
            } @else {
              No hay contactos que coincidan con "{{ searchTerm() }}".
            }
          </p>
        </ion-label>
      </ion-item>
    }
  }
</ion-content>
